import axios, { AxiosInstance } from "axios";
import { UserResponse } from "../interfaces/UserResponse";
import { EmailRequest } from "../interfaces/EmailRequest";
import { UpdateUserPasswordRequest } from "../interfaces/UpdateUserPasswordRequest";

import key from "../key";

export const headers: HeadersInit = {
    "Accept": "application/json",
    "Content-Type": "application/json",
    "x-api-key": "17&*up#od@f$dwqrg+iji8b(9l88b+067fnui@!o&q-&krp8j2"
};

export const apiCreate: AxiosInstance = axios.create({
    baseURL: key.apiServerUrl,
    headers
});

apiCreate.interceptors.response.use(
    (response) => response,
    (error) => {
        console.error("AXIOS ERROR:", error);

        if (error.request) console.log("Request:", error.request);
        if (error.response) console.log("Response:", error.response);

        return Promise.reject(error);
    }
);

export const getAllUsers = async (): Promise<UserResponse[] | null> => {
    try {
        const response = await apiCreate.get("/users");
        return response.data;
    } catch (error: any) {
        console.error("Erro axios getUserByCard:", error);
        return null;
    }
};

export const getUserByCard = async (
    CPFCNPJ: string
): Promise<UserResponse | null> => {
    try {
        const response = await apiCreate.get(`/users-by-card/${CPFCNPJ}`);
        return response.data;
    } catch (error: any) {
        console.error("Erro axios getUserByCard:", error);
        return null;
    }
};

export const sendEmail = async (
    to: string,
    subject: string,
    html: string
): Promise<EmailRequest | null> => {
    const payload: EmailRequest = {
        to,
        subject,
        html,
    };

    try {
        const res = await axios.post(`${key.apiServerUrl}/send-email-transporter`,
            payload
        );

        return res.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const updateUserPassword = async (
    id: number, senha: string): Promise<any | null> => {
    const resultSchema: UpdateUserPasswordRequest = { id, senha };

    try {
        const res = await apiCreate.patch(`/users-update-password/${id}`,
            resultSchema
        );

        return res.data;
    } catch (error) {
        console.error(error);
        return null;
    }
};
